import { LayoutKey } from '@rapoo/device-sdk'
import type { InjectionKey, Ref } from 'vue'

export const SelectedKeySymbol: InjectionKey<Ref<SelectedKey>> = Symbol.for('selectedKey')
export const KeySettingsSymbol: InjectionKey<Ref<KeySetting[]>> = Symbol.for('keySettings')
export const UpdateSelectedKeyMappingSymbol = 'updateSelectedKeyMapping'
/** 与键盘侧同名，供复用的 TabMacro 在删宏前恢复已绑定按键 */
export const RestoreKeyMappingWithTargetSymbol = 'restoreKeyMappingWithTarget'

export type UpdateSelectedKeyMapping = (data: KeyChangePayload) => void
export type RestoreKeyMappingWithTarget = (targetKey: SelectedKey) => void

export type SelectedKey = LayoutKey | null

export type KeyType = 'normal' | 'media' | 'macro' | 'keyboard' | 'combinedKey'

/**
 * keycode name/alias 对象结构
 */
export type KeycodeLabel = {
  standard?: string
  windows?: string
  macx?: string
  linux?: string
}

/**
 * keycode.json 中单条键位元数据结构。
 */
export type KeycodeMetaItem = {
  keywords: string
  name: string | KeycodeLabel
  alias?: string | KeycodeLabel
  type: string
  stype: string
  code: string
  sys_code?: {
    windows: string[]
    linux: string[]
    macx: string[]
  }
  [key: string]: unknown
}

/**
 * 统一后的映射元数据，供 UI keySetting 生成使用。
 */
export type ResolveMappedMetaResult = {
  keywords: string
  keyType: Extract<KeyType, 'normal' | 'media' | 'configuration'>
  // mappedKeyCode?: string
  icon?: string
  confIndex?: number
}

export type LocalizedSpecialKeyMapItem = SpecialKeyMapItem & {
  labelKey?: string
}

// 键盘设置统一配置
export interface KeySetting {
  keywords: string // 原按键标识
  keyType?: KeyType
  isModified?: boolean // 原按键是否被修改
  target?: LayoutKey | LocalizedSpecialKeyMapItem | null // 原按键被映射的键
  raw?: any
  [key: string]: any
}

// 改键统一 payload
export interface KeyChangePayload {
  keywords: string // 原按键标识
  keyType: KeyType
  target: LayoutKey | LocalizedSpecialKeyMapItem | null // 原按键被映射的键
  raw: any
  [key: string]: any
}

export interface DragImageOptions {
  text?: string | null
  icon?: string
  width?: number
  height?: number
  offsetX?: number
  offsetY?: number
}

// export type LayoutKey = {
//   key?: number
//   keywords: string
//   // name?: string | { standard?: string; windows?: string; macx?: string; linux?: string }
//   // type?: string | number
//   // code?: string | number | Array<string | number>
//   confIndex?: string | number
// }

export type SpecialKeyMapItem = {
  keywords: string
  keyType: KeyType
  icon?: string
  confIndex?: number // 配置改键索引
}
